const VideoState = {
    videos:{},
    loading: false,
    error:false
}

export default VideoState;

